import React, { Component } from 'react'
import '../styles/Field.css'
import validator from 'email-validator'
import { injectIntl, defineMessages } from "react-intl"

class Field extends Component {

  constructor(props) {
    super(props)
    this.state = {
      input: this.props.input ? this.props.input : "",
      validate: true
    }
  }

  validateEmail = (email, elementId) => {
    if (this.props.email && !validator.validate(email) && this.state.input.length > 0) {
      this.setState({ validate: false })
      document.getElementById(elementId).classList.add("form-field-input--error")
      document.getElementById(elementId).closest(".form-field").style.marginBottom = "36px"
    } else if ((document.getElementById(elementId)) && (this.props.email && validator.validate(email) || this.state.input.length === 0) ) {
      this.setState({ validate: true })
      document.getElementById(elementId).classList.remove("form-field-input--error")
      document.getElementById(elementId).closest(".form-field").style.marginBottom = "0"
    }
  }

  handleChange = (e) => {
    if (!this.state.validate) {
      this.validateEmail(e.target.value, e.target.id)
    }
    this.props.onChange(e.target.value)
  }

  handleBlur = (e) => {
    if (this.props.email) {
      this.validateEmail(e.target.value, e.target.id)
    }
  }

  handleType = () => {
    if (this.props.textarea) {
      return "textarea"
    } else if (this.props.number) {
      return "number"
    } else {
      return "text"
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props

    const style = this.props.textarea
      ? "form-field form-field--text-area"
      : "form-field"

    const labelStyle = this.state.input !== "" || this.props.input
      ? "form-field-label form-field-label--active"
      : "form-field-label"

    const FieldType = this.props.textarea
      ? "textarea"
      : "input"

    const idGenerator = () => {
      if (this.props.id) {
        return this.props.id
      } else if (this.props.email) {
        return this.props.email
      } else {
        return ""
      }
    }
    return (
      <div className={style}>
        <FieldType
          className="form-field-input"
          name={this.props.name}
          value={this.props.input}
          required={this.props.required}
          disabled={this.props.disabled}
          id={idGenerator()}
          onChange={e => {this.setState({ input: e.target.value }, this.handleChange(e))}}
          onBlur={e => this.handleBlur(e)}
          type={this.handleType()}
          >
        </FieldType>
        <span className={labelStyle}>{this.props.placeholder}</span>
        {
          this.props.email && !this.state.validate
          ?
            <span className="form-field-error-message">
              <span className="form-field-error-message-cross"></span>
            <span>{formatMessage(messages.error)}</span></span>
          : null
        }

      </div>
    )
  }
}

const messages = defineMessages({
  error: {
    id: 'field.error',
    defaultMessage: 'Veuillez entrer une adresse email correcte'
  }
})

export default injectIntl(Field)



// WEBPACK FOOTER //
// ./src/components/Field.js